module.exports = __webpack_public_path__ + "static/media/signup-dashboard.e2d7227a.webp";